import { useAlert, useNotification } from '@btime/react-messager'
import { useMutation, gql } from '@apollo/client'
import { useTranslation } from 'react-i18next'

import { generalClient } from '../../../../utils/apollo/api'

const MUTATION = gql`
  mutation RemoveScreenView($id: Int) {
    removeScreenView(id: $id)
  }
`

export const useRemoveView = () => {
  const notify = useNotification()
  const { t } = useTranslation('common')
  const [request, state] = useMutation(MUTATION, { client: generalClient })
  const modal = useAlert()

  const handleRequest = id => {
    if (!modal.confirm({ title: t('widgets.removeScreenItem.confirm') })) return false

    return request({ variables: { id } }).then(resp => {
      if (!resp.errors) {
        notify.success({ title: t('screenViews.remove.success') })
      } else {
        notify.error({ title: t('errors.remove') })
      }
    })
  }

  return [handleRequest, state]
}
